import React from 'react';
import FormWrapper from "../../../library/form/components/FormWrapper";
import SarasTrans from "../../../library/notifications/SarasTrans";
import SarasTooltip from '../../../library/notifications/SarasTooltip';

const InvMergeBatchSummary = (props) => {
    const { formObject, rowKey, mergeSummary } = props;
    const canMerge = mergeSummary?.CAN_MERGE ?? false;
    const mergeNote = mergeSummary?.MERGE_NOTE || "";
    const showQty2 = mergeSummary?.viewFormatter?.TOTAL_QTY2?.isVisible !== 0;

    return (
        <FormWrapper customWrapper="div" wrapperClass="uiSpacerT10" formObject={formObject} rowKey={rowKey} action={{ paramName: "mergeSummary" }} >
            <div className="uiInline" style={{ gap: "10px", flexWrap: "wrap", padding: "0px", backgroundColor: "#f7fbff", border: "1px solid #d9e8fb", borderRadius: "10px" }}>
                <SarasTooltip title={!canMerge ? mergeNote : ""}>
                    <span
                        className="uiInline"
                        style={{
                            padding: "2px 10px",
                            borderRadius: "999px",
                            fontWeight: "600",
                            backgroundColor: canMerge ? "#e7f7ee" : "#fdecec",
                            color: canMerge ? "#157347" : "#c92a2a"
                        }}
                    >
                        <SarasTrans value={canMerge ? "Can Merge" : "Cannot Merge"} />
                    </span>
                </SarasTooltip>
                <div className="phKeyValueView">
                    <span className="uiKey"><SarasTrans value="Batches" /></span>
                    <span className="uiValue uiSpacerL5">{mergeSummary?.BATCH_COUNT ?? 0}</span>
                </div>
                <div className="phKeyValueView">
                    <span className="uiKey"><SarasTrans value="Total Qty1" /></span>
                    <span className="uiValue uiSpacerL5">{mergeSummary?.TOTAL_QTY1?.label ?? 0}</span>
                </div>
                {showQty2 ? (
                    <div className="phKeyValueView">
                        <span className="uiKey"><SarasTrans value="Total Qty2" /></span>
                        <span className="uiValue uiSpacerL5">{mergeSummary?.TOTAL_QTY2?.label ?? 0}</span>
                    </div>
                ) : null}
                <div className="phKeyValueView">
                    <span className="uiKey"><SarasTrans value="Avg Cost" /></span>
                    <span className="uiValue uiSpacerL5">{mergeSummary?.AVG_COST?.label ?? 0}</span>
                </div>
            </div>
        </FormWrapper>
    );
};

export default InvMergeBatchSummary;
